require('./brokerFundamentalAnalysisForm.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { formatText, FormattedText } = require('core/i18n').i18n;
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');
const { InputSafe } = require('commonsComponents/inputSafe');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { OKButton } = require('components/commons/OKButton/OKButton');
const moment = require('moment');
// @constants
const { DATE_PICKER_CUSTOM_PLACEHOLDER, DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');

class BrokerFundamentalAnalysisForm extends React.Component {
    constructor(props) {
        super(props);

        this.handleFormValueName = this.handleFormValueName.bind(this);
        this.onHandleChangeDateFrom = this.onHandleChangeDateFrom.bind(this);
        this.onHandleChangeDateTo = this.onHandleChangeDateTo.bind(this);
        this.handleChangeSearchSector = this.handleChangeSearchSector.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.buildTabValue = this.buildTabValue.bind(this);
        this.buildTabSector = this.buildTabSector.bind(this);
        this.buildTabDate = this.buildTabDate.bind(this);
    }

    onHandleChangeDateFrom(momentDateObject) {
        this.props.changeDateFrom(momentDateObject);
    }

    onHandleChangeDateTo(momentDateObject) {
        this.props.changeDateTo(momentDateObject);
    }

    buildLegend(legend) {
        return (
            <legend className="broker-fundamental-analysis-form__legend">
                {legend}
            </legend>
        );
    }

    buildTabDate() {
        const selectedDateFrom = this.props.immFormData.get('dateFrom') || null;
        const selectDateFromMinDate = moment().startOf('day').subtract('1', 'years');
        const selectedDateTo = this.props.immFormData.get('dateTo') || null;
        const selectedDateToMinDate = this.props.immFormData.get('dateFrom') || null;
        const selectedDateMaxDate = moment().startOf('day');

        return (
            <div className="broker-fundamental-analysis-form__date-picker-container">
                <label className="broker-fundamental-analysis-form__date-picker-content" htmlFor="fundamentalAnalysisDatePickerFrom">
                    <span className="broker-fundamental-analysis-form__date-picker-label">{formatText('broker-fundamentalAnalysisSearchFrom')}</span>
                    <div className="broker-fundamental-analysis-form__date-picker">
                        <DatePickerCustom
                            callback={this.onHandleChangeDateFrom}
                            minDate={selectDateFromMinDate}
                            maxDate={selectedDateMaxDate}
                            selectedDate={selectedDateFrom}
                            placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                            locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                            dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                        />
                    </div>
                </label>
                <label className="broker-fundamental-analysis-form__date-picker-content" htmlFor="fundamentalAnalysisDatePickerTo">
                    <span className="broker-fundamental-analysis-form__date-picker-label">{formatText('broker-fundamentalAnalysisSearchTo')}</span>
                    <div className="broker-fundamental-analysis-form__date-picker">
                        <DatePickerCustom
                            callback={this.onHandleChangeDateTo}
                            minDate={selectedDateToMinDate}
                            maxDate={selectedDateMaxDate}
                            selectedDate={selectedDateTo}
                            placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                            locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                            dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                            innerSmallContainer
                        />
                    </div>
                </label>
                <span className="broker-fundamental-analysis-form__dates-submit">
                    <OKButton
                        id="btnFundamentalAnalysisByDatesRangeSubmit"
                        onClick={this.handleSubmit}
                    >
                        <FormattedText value="broker-fundamentalAnalysisSearchButton" />
                    </OKButton>
                </span>
            </div>
        );
    }

    buildTabSector() {
        const { immData, immFormData } = this.props;
        const sectorsData = immData.get('sectors');
        const sectorsArray = [];
        sectorsData.map((sector) => {
            sectorsArray.push({ value: sector.get('value'), label: sector.get('label') });
        });

        return (
            <div>
                <span className="broker-fundamental-analysis-form__input">
                    <OKSelect
                        id="selFundamentalAnalysisBySector"
                        name="input-sector"
                        label={formatText('broker-fundamentalAnalysisSector')}
                        onChange={this.handleChangeSearchSector}
                        placeholder={formatText('broker-fundamentalAnalysisSelectorPlaceholder')}
                        options={sectorsArray}
                        extraClass="broker-fundamental-analysis-form__input"
                        value={immFormData.get('sector')}
                    />
                </span>
                <span className="broker-fundamental-analysis-form__sector-submit">
                    <OKButton
                        id="btnFundamentalAnalysisBySectorSubmit"
                        onClick={this.handleSubmit}
                    >
                        <FormattedText value="broker-fundamentalAnalysisSearchButton" />
                    </OKButton>
                </span>
            </div>
        );
    }

    buildTabValue() {
        return (
            <div>
                <span className="broker-fundamental-analysis-form__input">
                    <InputSafe
                        id="inpFundamentalAnalysisByValue"
                        label={formatText('broker-fundamentalAnalysisSearchValueName')}
                        onChange={this.handleFormValueName}
                        type="text"
                        value={this.props.immFormData.get('value')}
                    />
                </span>
                <span className="broker-fundamental-analysis-form__value-submit">
                    <OKButton
                        id="btnFundamentalAnalysisByValueSubmit"
                        onClick={this.handleSubmit}
                    >
                        <FormattedText value="broker-fundamentalAnalysisSearchButton" />
                    </OKButton>
                </span>
            </div>
        );
    }

    handleChangeSearchSector(selectedObject) {
        this.props.changeSector(selectedObject.value);
    }

    handleFormValueName(evt) {
        this.props.changeValue(evt.target.value);
    }

    handleSubmit() {
        this.props.onSubmit();
    }

    render() {
        const { selectedFilter } = this.props;
        let children;
        let legend = '';

        switch (selectedFilter) {
            case 'filterValue':
                children = this.buildTabValue();
                break;
            case 'filterSector':
                children = this.buildTabSector();
                break;
            case 'filterDate':
                legend = this.buildLegend(formatText('broker-fundamentalAnalysisSearchDateIssueDate'));
                children = this.buildTabDate();
                break;
        }

        return (
            <fieldset className="broker-fundamental-analysis-form">
                {legend}
                {children}
            </fieldset>
        );
    }
}

BrokerFundamentalAnalysisForm.propTypes = {
    selectedFilter: PropTypes.string,
    immFormData: PropTypes.object,
    immData: PropTypes.object,
    changeSector: PropTypes.func,
    changeDateFrom: PropTypes.func,
    changeDateTo: PropTypes.func,
    changeValue: PropTypes.func,
    onSubmit: PropTypes.func
}

module.exports = BrokerFundamentalAnalysisForm;
